"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageFile = void 0;
const getMultiLanguageFile_1 = __importDefault(require("@/data-manager/multi-language/getMultiLanguageFile"));
const getLanguageFile = (subUrls, callback) => {
    Promise.all(subUrls.map(subUrl => (0, getMultiLanguageFile_1.default)(subUrl).then(resp => resp))).then(texts => {
        console.log('stitcher---getLanguageFile');
        console.log(texts);
        if (Array.isArray(texts) && texts.length > 0) {
            if (callback && typeof callback === 'function') {
                callback({
                    state: 'success',
                    data: texts
                });
            }
        }
    });
};
exports.getLanguageFile = getLanguageFile;
